// How far an achievable figure falls short of what it is read against: amber, or red
// for a big gap; nothing for a small one.
export type Tone = "amber" | "red";

// Size: within 5% of the ceiling is not flagged, 5-15% short is amber, more is red.
export const sizeGap = (
  achievable: number | string,
  base: number | string,
): Tone | undefined => {
  const short = (Number(base) - Number(achievable)) / Number(base);
  return short > 0.15 ? "red" : short >= 0.05 ? "amber" : undefined;
};
